import { AccountingTouchDetailView } from "@/pages/dashboard/admin/AccountingTouchDetailView";
import { PayrollExportView } from "@/pages/dashboard/admin/PayrollExportView";
import { TouchDetailExportView } from "@/pages/dashboard/admin/TouchDetailExportView";

export function AdminExportReportsView() {
  return (
    <div className="mt-4 grid grid-cols-1 gap-4 [&>*]:min-w-0">
      <PayrollExportView />
      <TouchDetailExportView />
      <AccountingTouchDetailView />
    </div>
  );
}
